module.exports = __webpack_public_path__ + "static/media/bcbs.56ffcc77.png";